import React from "react";
import { Layers, Hash, FileText, CheckCircle2 } from "lucide-react";
import { FormInput, FormSelect, FormTextarea } from "./SharedFormComponents";

export const CategoryForm = ({ form, errors, handleInputChange }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 animate-in fade-in slide-in-from-bottom-2 duration-300">
      <FormInput
        icon={<Layers size={14} />}
        label="Category Name"
        required
        field="categoryName"
        value={form.categoryName}
        onChange={handleInputChange}
        error={errors.categoryName}
        placeholder="e.g. Hardware, Boards"
      />
      <FormInput
        icon={<Hash size={14} />}
        label="Category Code"
        required
        field="categoryCode"
        value={form.categoryCode}
        onChange={handleInputChange}
        error={errors.categoryCode}
        placeholder="e.g. HDW-001"
      />
      <div className="md:col-span-2">
        <FormTextarea
          icon={<FileText size={14} />}
          label="Description"
          field="description"
          value={form.description}
          onChange={handleInputChange}
          error={errors.description}
          placeholder="Category details..."
        />
      </div>
      <div className="md:col-span-2">
        <FormSelect
          icon={<CheckCircle2 size={14} />}
          label="Status"
          required
          field="status"
          options={[
            { value: "ACTIVE", label: "Active" },
            { value: "INACTIVE", label: "Inactive" },
          ]}
          value={form.status || "ACTIVE"}
          onChange={handleInputChange}
          error={errors.status}
        />
      </div>
    </div>
  );
};
